<div id="handelsregistereintragAngaben">

  <div class="d-flex justify-content-between mb-3x pt-1">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.TITEL' | translate }}</h2>
    <common-ui-daten-uebernahme (picked)="onHandelsregistereintragPicked($event)"
                                [itemTemplate]="datenuebernahmeHandelsregistereintrag"
                                [items]="stammdaten?.unternehmen?.handelsregistereintrag" [readonly]="readonly"
                                context="Handelsregistereintrag"></common-ui-daten-uebernahme>
  </div>

  <div class="mb-5x">
    <common-ui-handelsregistereintrag
      [(data)]="data" [readonly]="readonly">
    </common-ui-handelsregistereintrag>
  </div>

</div>

<ng-template #datenuebernahmeHandelsregistereintrag let-item="item">

  <h4 class="list-group-item-heading">
    {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.STAMMDATEN_LABEL' | translate }}
  </h4>

  <div *ngIf="item?.handelsregisterBezeichnung">
    {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.HANDELSREGISTERBEZEICHNUNG_LABEL' | translate }} {{item?.handelsregisterBezeichnung}}
  </div>

  <div *ngIf="item?.handelsregisterNummer">
    {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.HANDELSREGISTERNUMMER_LABEL' | translate }} {{item?.handelsregisterNummer}}
  </div>

  <div *ngIf="item?.eingetragenAm">
    {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.EINGETRAGENAM_LABEL' | translate }} {{ item?.eingetragenAm}}
  </div>

  <div *ngIf="item?.ortRegistergericht">
    {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ORTREGISTERGERICHT_LABEL' | translate }} {{item?.ortRegistergericht}}
  </div>
</ng-template>
